var ReportAPI = require('../api').Report;


module.exports = function($scope, $rootScope){
  var vm = this;
  vm.reports = [];  
  vm.userId = $rootScope.auth.user_id;

  vm.init = function(){
    vm.loading = true;
    return ReportAPI.GetReportsByType(1).then(function(results){
      vm.reports = results;
      vm.loading = false;
      });
    }

  vm.init();
}
